import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';
import useMitgliederSuche, { trefferZusatz } from '@/hooks/useMitgliederSuche';

// Person suchen und auswählen (Empfehlungsaktion 30.09.2026: „Geworben von“).
//
// Seit 03.10.2026 über die Personensuche des Empfangs (GET /api/checkins/suche) statt
// über die Lead-Liste: Die Lead-Liste zeigt ohne Lead-Recht nur eigene Leads — die Rolle
// „Closer (Empfang)“ fand im Verkaufsrechner deshalb kein werbendes Mitglied —, sucht
// nur ganze Wörter und blendet archivierte Personen aus.
export default function MitgliedSuche({ wert, onWahl, placeholder = 'Name suchen…', ausser, tid }) {
  const [q, setQ] = useState('');
  const suche = useMitgliederSuche(q, { limit: 8 });
  const treffer = suche.treffer.filter(l => l.id !== ausser);

  if (wert) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-border/60 bg-white px-3 py-2 text-sm dark:bg-transparent" data-testid={tid}>
        <span className="flex-1 font-medium">{wert.name}{wert.zusatz && <span className="font-normal text-muted-foreground"> · {wert.zusatz}</span>}</span>
        <button type="button" onClick={() => onWahl(null)} className="text-muted-foreground hover:text-foreground" aria-label="Auswahl entfernen"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div className="space-y-1.5" data-testid={tid}>
      <Input value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
        placeholder={placeholder} className="h-9" />
      {treffer.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {treffer.map(l => {
            // Gleichnamige unterscheiden: Mitglied, Mitgliedsnummer und, falls geliefert, Jahrgang und Anlagemonat
            const zusatz = [trefferZusatz({ ...l, email: null }), l.archiviert ? 'Archiv' : null].filter(Boolean).join(' · ');
            return (
              <button key={l.id} type="button" onClick={() => { onWahl({ id: l.id, name: l.name, zusatz }); setQ(''); }}
                className="rounded-full border border-border px-3 py-1 text-xs hover:bg-muted" data-testid={tid ? `${tid}-treffer-${l.id}` : undefined}>
                {l.name}{zusatz && <span className="text-muted-foreground"> · {zusatz}</span>}
              </button>
            );
          })}
        </div>
      )}
      {suche.laedt && <p className="text-[11px] text-muted-foreground">Sucht…</p>}
      {suche.fehler && (
        <p className="text-[11px] text-red-600 dark:text-red-400">
          {suche.keinRecht ? 'Dieses Konto darf hier nicht suchen.' : (
            <>Die Suche hat nicht geantwortet. <button type="button" className="underline" onClick={suche.erneut}>Erneut suchen</button></>
          )}
        </p>
      )}
      {!suche.leer && !suche.zuKurz && !suche.laedt && !suche.fehler && treffer.length === 0 && (
        <p className="text-[11px] text-muted-foreground">Niemand gefunden.</p>
      )}
      {suche.mehr && <p className="text-[11px] text-muted-foreground">Es gibt weitere Treffer – bitte genauer suchen.</p>}
    </div>
  );
}
